import * as React from 'react';

const SvgHeartDefault: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.223 19.29h-.001c-2.595-2.354-4.668-4.236-6.104-5.992C3.693 11.556 3 10.062 3 8.5 3 5.972 4.972 4 7.5 4c1.437 0 2.832.674 3.739 1.738l.761.894.761-.894C13.668 4.674 15.063 4 16.5 4 19.028 4 21 5.972 21 8.5c0 1.562-.693 3.056-2.118 4.8-1.436 1.757-3.509 3.64-6.103 5.999h-.002l-.774.701-.78-.71z"
        fill="currentcolor"
        stroke="currentcolor"
        strokeWidth={2}
      />
    </svg>
  );
};

export default SvgHeartDefault;
